export enum TitleLogoType {
  DefaultLogo = 0,
  Engage,
  ProfessionalServices,
  Foundation,
}
